import { createAction } from '@reduxjs/toolkit';

export const addPost = createAction<number>('previouslyViewedPosts/addPost');
